module.exports = __webpack_public_path__ + "static/media/owl-bubble.c23e9c10.svg";